<template>
  <svg :width="width" :height="height" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3332 1L4.99984 8.33333L1.6665 5" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#FB923C',
      required: false,
    },
    width: {
      type: Number,
      default: 14,
    },
    height: {
      type: Number,
      default: 10,
    },
  },
};
</script>
